import styled from 'styled-components';

export const ChatWidgetContainer = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
`;

export const ChatToggleButton = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #1890ff;
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  transition: all 0.3s ease;

  &:hover {
    background: #40a9ff;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 46px;
  right: 24px;
  width: 700px;
  height: 800px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    width: calc(100vw - 48px);
    height: 500px;
  }
`;

export const ChatHeader = styled.div`
  padding: 14px 10px;
  background: linear-gradient(90deg, #fa66ca 0%, #00b1ca 100%);
  color: white;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const MessageWrapper = styled.div<{ type: 'user' | 'bot' }>`
  display: flex;
  align-items: flex-start;
  align-self: ${props => (props.type === 'user' ? 'flex-end' : 'flex-start')};
  gap: ${props => (props.type === 'bot' ? '12px' : '0')};
  max-width: 70%;
`;

export const AIAvatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #0693c4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MessageBubble = styled.div<{ type: 'user' | 'bot' }>`
  padding: ${props => (props.type === 'user' ? '10px 12px' : '0')};
  border-radius: 16px;
  background: ${props => (props.type === 'user' ? '#fff' : 'transparent')};
  border: ${props => (props.type === 'user' ? '1px solid #1890ff' : 'none')};
  word-wrap: break-word;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const FeedbackRow = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;

  .ant-btn {
    color: #8c8c8c;
  }

  .ant-btn.selected {
    color: #1890ff;
  }
`;

export const CommentBox = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const InputContainer = styled.div`
  padding: 24px 16px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  gap: 16px;
  background: linear-gradient(90deg, #ffddf7 0%, #c9e5fc 100%);

  .ant-input {
    flex: 1;
  }
`;
